import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EBuildersLocationsActionType, TStartFetching } from './types';

export const startFetching: () => TStartFetching = actionGenerator<EBuildersLocationsActionType.StartFetching>(
  EBuildersLocationsActionType.StartFetching,
);
